import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Gift(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Gift", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.2282 8.97594c-.6669-1.20535-1.6447-2.20994-2.8316-2.90919-1.1868-.69925-2.5394-1.06761-3.917-1.06673H7.3152c-.30435-.00112-.60591.058-.8873.17396-.2814.11595-.53706.28644-.75227.50165-.21521.21521-.3857.47087-.50165.75227-.11596.28139-.17508.58295-.17396.8873.00058 1.53843.57995 3.0203 1.62296 4.1512 1.043 1.1309 2.4733 1.828 4.00662 1.9527v.7291H24V9.22224l-3.7718-.2463Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M16.963 11.3336c-.0579-.0001-.1156-.0072-.1718-.0211l-5.6296-1.4074c-.1798-.04643-.3341-.1621-.429-.32177-.0949-.15968-.1229-.35041-.0777-.53061.0451-.18019.1597-.33523.3187-.4313.159-.09606.3495-.12536.53-.08151l5.6296 1.40741c.1665.04173.312.14288.4092.28438.0971.1415.1392.3137.1182.484-.0209.1704-.1034.3272-.2319.441-.1285.1138-.2941.1767-.4657.1769Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.7719 8.97594c.6668-1.20535 1.6446-2.20994 2.8315-2.90919 1.1868-.69925 2.5394-1.06761 3.917-1.06673h6.1644c.3044-.00112.6059.058.8873.17396.2814.11595.5371.28644.7523.50165.2152.21521.3857.47087.5016.75227.116.28139.1751.58295.174.8873-.0006 1.53843-.58 3.0203-1.623 4.1512-1.043 1.1309-2.4733 1.828-4.0066 1.9527v.7291H24V9.22224l3.7719-.2463Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M31.0369 11.3336c.0579-.0001.1155-.0072.1717-.0211l5.6296-1.4074c.1799-.04643.3341-.1621.4291-.32177.0949-.15968.1228-.35041.0777-.53061-.0452-.18019-.1597-.33523-.3187-.4313-.159-.09606-.3495-.12536-.5301-.08151l-5.6296 1.40741c-.1665.04173-.312.14288-.4091.28438-.0971.1415-.1392.3137-.1183.484.021.1704.1034.3272.2319.441.1285.1138.2942.1767.4658.1769Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M25.5885 7.81494h-3.1779c-1.4543 0-2.6333 1.17895-2.6333 2.63326v.3631c0 1.4543 1.179 2.6333 2.6333 2.6333h3.1779c1.4543 0 2.6333-1.179 2.6333-2.6333v-.3631c0-1.45431-1.179-2.63326-2.6333-2.63326Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M41.5926 20.4815v19.7037c0 .7465-.2966 1.4625-.8244 1.9904-.5279.5279-1.2439.8244-1.9904.8244H9.22222c-.74653 0-1.46249-.2965-1.99037-.8244-.52788-.5279-.82444-1.2439-.82444-1.9904V20.4815H41.5926Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M27.5185 20.4815h-7.037V43h7.037V20.4815Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M41.5926 13.4445H6.40741C5.63012 13.4445 5 14.0746 5 14.8519v5.6296c0 .7773.63012 1.4074 1.40741 1.4074H41.5926c.7773 0 1.4074-.6301 1.4074-1.4074v-5.6296c0-.7773-.6301-1.4074-1.4074-1.4074Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M29.25 12.75h-10.5v9h10.5v-9Z", fill: theme.vars.palette.primary.dark })
  ] });
}
Gift.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Gift"
};
validateTidalLicense();
export {
  Gift
};
//# sourceMappingURL=Gift.js.map
